import React, { useEffect, useRef, useState } from "react";
import { listTimetableWeeks, createTimetableWeek, getWeekConfigSummary, listTimetableRuns, setWeekBusyOpen, setWeekExcludeChamCong, renameTimetableWeek, deleteTimetableWeek, publishTimetableRun, unpublishTimetableRun, listMySchools, getLatestPublishedRun, getPublishedRuns } from "./happyschoolApi";
import HappySchoolTimetableTrash from "./HappySchoolTimetableTrash";
import HappySchoolPublishLog from "./HappySchoolPublishLog";
import { getActiveSchoolId } from "./activeSchool";
import HappySchoolTeacherBusy from "./HappySchoolTeacherBusy";
import HappySchoolTKBNghe from "./HappySchoolTKBNghe";
import HappySchoolVanhoaDistribution from "./HappySchoolVanhoaDistribution";
import HappySchoolRunTKB from "./HappySchoolRunTKB";
import HappySchoolPreflightCheck from "./HappySchoolPreflightCheck";
import HappySchoolSubjectConfig from "./HappySchoolSubjectConfig";
import HappySchoolBlockSizeConfig from "./HappySchoolBlockSizeConfig";
import HappySchoolTimetableVersion from "./HappySchoolTimetableVersion";
import HappySchoolScheduleStats from "./HappySchoolScheduleStats";
import HappySchoolSubstituteStats from "./HappySchoolSubstituteStats";
import HappySchoolAllTeachersView from "./HappySchoolAllTeachersView";
import HappySchoolSubstituteBoard from "./HappySchoolSubstituteBoard";
import HappySchoolPostPublishChanges from "./HappySchoolPostPublishChanges";
import HappySchoolAllClassesView from "./HappySchoolAllClassesView";
import HappySchoolPendingEdits from "./HappySchoolPendingEdits";
import HappySchoolDataTable from "./HappySchoolDataTable";
import HappySchoolManualLocks from "./HappySchoolManualLocks";
import HappySchoolManualLockPriority from "./HappySchoolManualLockPriority";
import HappySchoolClassRelock from "./HappySchoolClassRelock";
import HappySchoolPccmQuickEdit from "./HappySchoolPccmQuickEdit";
import HappySchoolPccmByWeek from "./HappySchoolPccmByWeek";
import HappySchoolSubjectPriority from "./HappySchoolSubjectPriority";
import HappySchoolRunReport from "./HappySchoolRunReport";
import HappySchoolRunTotals from "./HappySchoolRunTotals";
import HappySchoolRoomAssignment from "./HappySchoolRoomAssignment";

// Các nút con dưới mỗi tuần TKB.
const CHILDREN = [
  { key: "pccmweek", label: "Phân công chuyên môn (riêng tuần này)", icon: "🎓" },
  { key: "lichban", label: "Lịch bận của thầy cô", icon: "🧑‍🏫" },
  { key: "tkbnghe", label: "TKB nghề", icon: "🛠️" },
  { key: "monhoc", label: "Cấu hình môn học", icon: "📖" },
  { key: "blocksize", label: "Cấu hình blockSize môn học", icon: "🧱" },
  { key: "vanhoanghe", label: "Lịch phân phối nghề-văn hoá", icon: "📚" },
  { key: "phonghoc", label: "Phân phòng học", icon: "🚪" },
  { key: "pccm", label: "Phân công chuyên môn", icon: "🎓" },
  { key: "xeptay", label: "Case xếp tay", icon: "🔧" },
  { key: "xeptay_tg", label: "Case xếp tay Thỉnh Giảng", icon: "🔧", sub: true },
  { key: "xeptay_ttn12", label: "Case xếp tay Môn TTN 12", icon: "🔧", sub: true },
  { key: "xeptay_uutien", label: "Xếp tay theo thứ tự ưu tiên", icon: "🔧", sub: true },
  { key: "xeptay_calop", label: "Xếp tay lại cả lớp", icon: "🔧", sub: true },
  { key: "diemuutien", label: "Điểm ưu tiên xếp môn", icon: "🎯" },
  { key: "kiemtra", label: "Kiểm tra trước khi xếp", icon: "🔍" },
  { key: "chayxep", label: "Chạy xếp TKB", icon: "🚀" },
];
// Các mục cấu hình con có thể sao chép từ 1 tuần đã có khi tạo tuần mới (key khớp WEEK_COPY_ITEMS ở API).
const COPY_ITEM_KEYS = ["pccmweek", "lichban", "tkbnghe", "monhoc", "blocksize", "vanhoanghe", "phonghoc", "xeptay"];
// Mỗi version (bản xếp) hiện đúng các file mà bản export TKB tạo ra.
const VIEWS = [
  { key: "baocao", label: "Báo cáo", icon: "📋" }, // thiếu tiết, liền tiết, GV quá tải/ít tiết/nghỉ dài
  { key: "baocaotongtiet", label: "Báo cáo Tổng tiết", icon: "🧮" }, // tổng số tiết Cơ hữu / Thỉnh giảng của tuần
  { key: "vh", label: "TKB Toàn trường VH", icon: "🏫" },           // TKB_ToanTruong_VH.xlsx
  { key: "vhnghe", label: "TKB Toàn trường VH-Nghề", icon: "🏭" },  // TKB_ToanTruong_VH_HN.xlsx
  { key: "teacher", label: "TKB Giáo viên", icon: "🧑‍🏫" },          // TKB_GiaoVien.xlsx
  { key: "teacherAll", label: "TKB Giáo viên — Toàn trường", icon: "🧑‍🏫" }, // TKB từng GV xếp liên tiếp, không cần chọn combobox
  { key: "teacherSub", label: "TKB Giáo viên — Dạy Thay", icon: "🔄" }, // GV bận/vắng theo ngày + các tiết cần dạy thay
  { key: "pendingEdits", label: "Sửa TKB — Xác nhận", icon: "🔔" }, // (24/10/2026) admin sửa áp dụng ngay, GVCN/GV liên quan vào xác nhận
  { key: "approvedEdits", label: "Sửa TKB — Đã xác nhận", icon: "✅" },
  { key: "postPublish", label: "Chỉnh sửa sau công bố", icon: "✏️" }, // các ô sửa sau khi công bố, theo lớp + GVCN
  { key: "teacherGridSang", label: "TKB GV-VH Buổi Sáng", icon: "🌤️" },  // toàn trường, 1 dòng/GV
  { key: "teacherGridChieu", label: "TKB GV-VH Buổi Chiều", icon: "🌆" }, // toàn trường, 1 dòng/GV
  { key: "teacherGridNgheSang", label: "TKB GV-Nghề Buổi Sáng", icon: "🛠️🌤️" },  // toàn trường, 1 dòng/GV dạy nghề
  { key: "teacherGridNgheChieu", label: "TKB GV-Nghề Buổi Chiều", icon: "🛠️🌆" }, // toàn trường, 1 dòng/GV dạy nghề
  { key: "student", label: "TKB cho GV & Học sinh", icon: "🎒" },   // TKB_ChoGiaoVienHocSinh.xlsx
  { key: "studentAll", label: "TKB cho GV & Học sinh — Toàn trường", icon: "🎒" }, // TKB từng lớp xếp liên tiếp, không cần chọn combobox
  { key: "studentPrintAll", label: "TKB Học sinh — Toàn trường (In)", icon: "🖨️" }, // mỗi lớp 1 trang, Nghỉ + học nghề để trống
  { key: "studentOnly", label: "TKB Riêng cho Học sinh", icon: "📖" }, // TKB_GianhRiengChoHocSinh.xlsx
  { key: "phonghoc", label: "Phòng học", icon: "🚪" }, // (04/11/2026) bảng phân phòng của tuần (chỉ xem; sửa ở mục "Phân phòng học" của tuần)
  { key: "chamcong", label: "Chấm công GV Văn hoá", icon: "🧮" },    // ChamCongGiaoVienVanHoaThang8.xlsx
  { key: "thongke", label: "Thống kê tiết vs Cấu hình môn học", icon: "📊" }, // so sánh grid với weekSubjectPlan
  { key: "thongkedaythay", label: "Thống kê dạy thay", icon: "🔁" }, // GV thực dạy khác GV chính PCCM
];
const fmtTime = (ts) => (ts ? new Date(ts).toLocaleString("vi-VN", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" }) : "");
const RUN_STATUS = { running: "đang xếp…", done: "", failed: "thất bại" };

// YYYY-MM-DD -> DD/MM
function fmt(d) {
  if (!d) return "";
  const p = String(d).split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}` : d;
}
// Nhãn hiển thị của 1 tuần: dùng tên riêng nếu có, không thì ghép từ ngày.
function weekLabel(w) {
  if (!w) return "";
  return w.name ? w.name : `Tuần ${fmt(w.startDate)}–${fmt(w.endDate)}`;
}
// Nhãn khối từ mảng khois (tương thích ngược với `khoi` chuỗi cũ).
function khoiLabel(w) {
  let arr = Array.isArray(w.khois) ? w.khois : w.khoi && w.khoi !== "all" ? [String(w.khoi)] : [];
  arr = arr.filter((k) => ["12", "11", "10"].includes(String(k)));
  if (arr.length === 0 || arr.length >= 3) return "Tất cả khối";
  return arr.slice().sort((a, b) => Number(b) - Number(a)).map((k) => `Khối ${k}`).join(", ");
}
const KHOI_OPTIONS = ["12", "11", "10"];

// onlyWeekId (21/10/2026): trang /happyschool/tkb/:weekId — cây CHỈ có đúng tuần TKB này (mở sẵn), ẩn "Tạo tuần".
const HappySchoolTKBManager = ({ onlyWeekId = null } = {}) => {
  const schoolId = getActiveSchoolId();
  const [weeks, setWeeks] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [expandedRun, setExpandedRun] = useState({}); // runId -> bool
  const [runsByWeek, setRunsByWeek] = useState({}); // weekId -> [runs]
  const [selected, setSelected] = useState(null); // { weekId, childKey } | { weekId, runId, viewKey }
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [khois, setKhois] = useState(["12", "11", "10"]);
  const [weekName, setWeekName] = useState(""); // tên riêng cho tuần (tuỳ chọn), vd "Tuần 21/09-26/09 v2"
  const [isBaoGiang, setIsBaoGiang] = useState(false); // tạo tuần "Báo giảng" (không tính lương/Chấm công)
  const [error, setError] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const toggleKhoi = (k) => setKhois((arr) => (arr.includes(k) ? arr.filter((x) => x !== k) : [...arr, k]));
  const [loading, setLoading] = useState(true);
  const [busyToggling, setBusyToggling] = useState("");
  const [chamCongToggling, setChamCongToggling] = useState("");
  const [renamingWeek, setRenamingWeek] = useState("");
  const [deletingWeek, setDeletingWeek] = useState("");
  const [copyFromWeekId, setCopyFromWeekId] = useState(""); // tuần nguồn để sao chép cấu hình ("" = không sao chép)
  const [copyItems, setCopyItems] = useState([]); // các mục con đã tích
  const [copyCounts, setCopyCounts] = useState(null); // { key: số dữ liệu } của tuần nguồn
  const [creatingWeek, setCreatingWeek] = useState(false); // chống bấm/gửi trùng "Tạo tuần" tạo nhiều bản ghi giống hệt nhau
  const [showTree, setShowTree] = useState(true); // ẩn cây quản lý -> nội dung (vd Lịch bận) rộng ra

  // Role "schedule_viewer" (Ban giám hiệu chỉ xem) -> rút gọn cây: CHỈ hiện
  // đúng tuần + bản đã công bố gần nhất, ẩn hết Tạo tuần/PCCM/Xếp tay/Thùng
  // rác/các bản nháp khác — đỡ rối cho vai trò không cần sửa gì, chỉ xem.
  const [myRole, setMyRole] = useState(null);
  const [roleLoaded, setRoleLoaded] = useState(false);
  useEffect(() => {
    if (!schoolId) return;
    listMySchools()
      .then((list) => setMyRole(((list || []).find((s) => s.id === schoolId) || {}).role || null))
      .catch(() => setMyRole(null))
      .finally(() => setRoleLoaded(true));
  }, [schoolId]);
  const viewerMode = myRole === "schedule_viewer";
  // Chỉ owner/admin (KHÔNG gồm Ban giám hiệu / vai trò khác) thấy nhóm "Case xếp tay" (xeptay*) trong cây tuần.
  const isStrictAdmin = myRole === "owner" || myRole === "admin";
  const isAdminRole = myRole === "owner" || myRole === "admin" || myRole === "schedule_viewer"; // owner/admin + Ban giám hiệu (schedule_viewer) xử lý được ô TKB (thay GV/để trống/trông lớp/điền ô)
  // BGH lấy THẲNG bản công bố mới nhất từ bảng publishedRuns (API
  // published-runs/latest, chỉ trả đúng 1 bản) — KHÔNG tải danh sách
  // tuần/danh sách bản xếp như admin (đọc toàn bộ bản xếp kèm lưới, rất chậm).
  const [latestPublished, setLatestPublished] = useState(null); // {weekId, runId, publishedAt, startDate, endDate, name, khois} | null
  const [latestPublishedLoaded, setLatestPublishedLoaded] = useState(false);
  useEffect(() => {
    if (!viewerMode || !schoolId) return;
    let stale = false;
    // Trang /happyschool/tkb/:weekId (onlyWeekId): BGH phải xem đúng bản công bố CỦA TUẦN ĐÓ — trước đây luôn lấy bản
    // công bố mới nhất toàn trường nên bấm tuần 19/10 lại hiện tuần khác.
    const load = onlyWeekId
      ? Promise.all([getPublishedRuns(schoolId), listTimetableWeeks(schoolId)]).then(([pubs, list]) => {
          const p = (pubs || []).find((x) => x.weekId === onlyWeekId) || null;
          const w = (list || []).find((x) => x.id === onlyWeekId) || null;
          return { p: p && w ? { ...p, name: w.name, khois: w.khois } : null, w };
        })
      : getLatestPublishedRun(schoolId).then((p) => ({ p, w: null }));
    load
      .then(({ p, w }) => {
        if (stale) return;
        setLatestPublished(p);
        setWeeks(p ? [{ id: p.weekId, startDate: p.startDate, endDate: p.endDate, name: p.name, khois: p.khois }] : (w ? [w] : []));
      })
      .catch((e) => { if (!stale) { setLatestPublished(null); setError(e.message); } })
      .finally(() => { if (!stale) setLatestPublishedLoaded(true); });
    return () => { stale = true; };
  }, [viewerMode, schoolId, onlyWeekId]);
  const viewerRuns = (weekId) =>
    latestPublished && latestPublished.weekId === weekId
      ? [{ id: latestPublished.runId, status: "done", finishedAt: latestPublished.publishedAt, published: true, demo: !!latestPublished.demo }]
      : [];
  // Tự mở đúng tuần + bản công bố gần nhất khi đã biết, để GV không cần bấm gì thêm.
  useEffect(() => {
    if (viewerMode && latestPublished) {
      setExpanded({ [latestPublished.weekId]: true });
      setExpandedRun({ [latestPublished.runId]: true });
    }
  }, [viewerMode, latestPublished]);

  // Mở/đóng cho phép giáo viên khai báo lịch bận của tuần này.
  const toggleBusyOpen = async (w) => {
    setBusyToggling(w.id); setError("");
    try { await setWeekBusyOpen(schoolId, w.id, !w.busyOpen); reload(); }
    catch (err) { setError(err.message); }
    finally { setBusyToggling(""); }
  };

  // Đánh dấu tuần "Báo giảng" — Chấm công sẽ bỏ hẳn tuần này (không phải
  // TKB dạy thật, chỉ để nộp báo cáo).
  const toggleExcludeChamCong = async (w) => {
    setChamCongToggling(w.id); setError("");
    try { await setWeekExcludeChamCong(schoolId, w.id, !w.excludeFromChamCong); reload(); }
    catch (err) { setError(err.message); }
    finally { setChamCongToggling(""); }
  };

  // Đặt/đổi tên riêng cho tuần, để phân biệt các tuần trùng ngày (vd bản sao).
  const renameWeek = async (w) => {
    const next = window.prompt("Tên hiển thị cho tuần này (để trống = hiện lại theo ngày):", w.name || "");
    if (next === null) return; // bấm Cancel
    setRenamingWeek(w.id); setError("");
    try { await renameTimetableWeek(schoolId, w.id, next.trim()); reload(); }
    catch (err) { setError(err.message); }
    finally { setRenamingWeek(""); }
  };

  // Xoá tuần TKB — chuyển vào thùng rác (soft-delete), khôi phục được từ mục
  // "🗑️ Thùng rác", không xoá thẳng vĩnh viễn.
  const deleteWeek = async (w) => {
    if (!window.confirm(`Xoá ${weekLabel(w)}?\nDữ liệu (cấu hình môn học, TKB nghề, lịch bận GV, các bản xếp lịch...) sẽ chuyển vào Thùng rác, khôi phục lại được khi cần.`)) return;
    setDeletingWeek(w.id); setError("");
    try {
      await deleteTimetableWeek(schoolId, w.id);
      setSelected(null);
      reload();
    } catch (err) { setError(err.message); }
    finally { setDeletingWeek(""); }
  };

  const loadedWeeks = useRef(new Set()); // tuần đã (đang) tải danh sách bản
  const reload = () => {
    if (!schoolId) return;
    setLoading(true);
    Promise.all([listTimetableWeeks(schoolId), getLatestPublishedRun(schoolId).catch(() => null)])
      .then(([list, latest]) => {
        // Tuần mới TẠO trước hiện lên đầu (không phải theo ngày bắt đầu tuần).
        let sorted = list.slice().sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
        if (onlyWeekId) {
          sorted = sorted.filter((w) => w.id === onlyWeekId);
          setExpanded({ [onlyWeekId]: true });
        }
        setWeeks(sorted);
        // Mặc định mở tuần có bản công bố MỚI NHẤT (không có thì tuần mới tạo nhất).
        const defId = latest && sorted.some((w) => w.id === latest.weekId) ? latest.weekId : sorted[0] && sorted[0].id;
        setExpanded((x) => (Object.keys(x).length === 0 && defId ? { [defId]: true } : x));
        loadedWeeks.current = new Set();
        setRunsByWeek({});
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };
  // Danh sách bản xếp tải THEO TỪNG TUẦN, chỉ khi tuần đó được mở ra trong cây
  // (lúc đầu chỉ tuần công bố mới nhất) — tuần khác bấm vào mới tải.
  const loadWeekRuns = (weekId) => {
    if (!weekId) return;
    loadedWeeks.current.add(weekId);
    listTimetableRuns(schoolId, weekId)
      .then((r) => setRunsByWeek((x) => ({ ...x, [weekId]: r })))
      .catch((e) => { loadedWeeks.current.delete(weekId); setError(e.message); });
  };
  useEffect(() => {
    if (viewerMode || loading) return;
    Object.keys(expanded).forEach((wid) => {
      if (expanded[wid] && !loadedWeeks.current.has(wid) && weeks.some((w) => w.id === wid)) loadWeekRuns(wid);
    });
    // eslint-disable-next-line
  }, [expanded, weeks, loading, viewerMode]);
  // Chờ biết role rồi mới tải: BGH (viewerMode) không cần danh sách tuần/bản.
  useEffect(() => {
    if (!roleLoaded) return;
    if (viewerMode) setLoading(false);
    else reload();
    // eslint-disable-next-line
  }, [schoolId, roleLoaded, viewerMode]);

  // Công bố 1 bản cho trang "TKB cho GV & Học sinh" — GV/học sinh CHỈ thấy
  // đúng bản này, các bản khác (kể cả bản mới hơn) chỉ owner/admin xem được ở
  // đây. Công bố bản mới tự bỏ công bố bản cũ cùng tuần (chỉ 1 bản/tuần).
  const [publishing, setPublishing] = useState("");
  // (24/10/2026) 2 kiểu công bố: "official" = chính thức; "demo" = GV/HS xem thử (nhãn DEMO), không tính chấm công/lương,
  // sửa ô áp dụng ngay không cần duyệt. Mỗi tuần vẫn chỉ 1 bản được công bố (Demo hay chính thức đều thay bản cũ).
  const publishRun = async (run, mode = "official") => {
    if (mode === "demo" && !window.confirm("Công bố bản này dạng DEMO (xem thử)?\n\n• GV/học sinh thấy TKB kèm nhãn DEMO.\n• KHÔNG tính chấm công / lương.\n• Sửa ô áp dụng ngay, không cần duyệt.\n• Thay bản đang công bố của tuần này (nếu có).")) return;
    setPublishing(run.id); setError("");
    try {
      await publishTimetableRun(schoolId, run.id, mode);
      loadWeekRuns(run.weekId);
    } catch (err) { setError(err.message); }
    finally { setPublishing(""); }
  };
  const unpublishRun = async (run) => {
    setPublishing(run.id); setError("");
    try {
      await unpublishTimetableRun(schoolId, run.id);
      loadWeekRuns(run.weekId);
    } catch (err) { setError(err.message); }
    finally { setPublishing(""); }
  };

  const pickCopySource = (weekId) => {
    setCopyFromWeekId(weekId); setCopyItems([]); setCopyCounts(null);
    if (!weekId) return;
    getWeekConfigSummary(schoolId, weekId).then((r) => setCopyCounts((r && r.counts) || {})).catch(() => setCopyCounts({}));
  };
  const toggleCopyItem = (k) => setCopyItems((arr) => (arr.includes(k) ? arr.filter((x) => x !== k) : [...arr, k]));

  const createWeek = async (e) => {
    e.preventDefault();
    if (!startDate || !endDate || creatingWeek) return;
    setError("");
    setCreatingWeek(true);
    try {
      const w = await createTimetableWeek(schoolId, startDate, endDate, khois, isBaoGiang, weekName.trim(), copyFromWeekId, copyFromWeekId ? copyItems : []);
      setStartDate("");
      setEndDate("");
      setKhois(["12", "11", "10"]);
      setWeekName("");
      setIsBaoGiang(false);
      setCopyFromWeekId(""); setCopyItems([]); setCopyCounts(null);
      setShowDialog(false);
      setExpanded((x) => ({ ...x, [w.id]: true }));
      reload();
    } catch (err) {
      setError(err.message);
    } finally {
      setCreatingWeek(false);
    }
  };

  if (!schoolId) return <p style={{ color: "#6b7280" }}>Chưa chọn trường.</p>;

  const selectedWeek = selected ? weeks.find((w) => w.id === selected.weekId) : null;
  const activeChild = selected && selected.childKey ? CHILDREN.find((c) => c.key === selected.childKey) : null;
  const activeView = selected && selected.viewKey ? VIEWS.find((v) => v.key === selected.viewKey) : null;


  return (
    <div>
      <button type="button" onClick={() => setShowTree((v) => !v)} style={treeToggleBtnStyle} title={showTree ? "Ẩn cây quản lý để nội dung rộng ra" : "Hiện lại cây quản lý"}>
        {showTree ? "« Ẩn cây quản lý" : "☰ Hiện cây quản lý"}
      </button>
      <div style={{ display: "flex", gap: 16, alignItems: "flex-start", flexWrap: "wrap" }}>
      {/* Cây quản lý */}
      {showTree && (
      <div style={{ width: 300, flexShrink: 0, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, padding: 12, boxSizing: "border-box" }}>
        {!viewerMode && !onlyWeekId && (
          <button type="button" onClick={() => { setError(""); setShowDialog(true); }} style={{ ...btnStyle, width: "100%", marginBottom: 12 }}>
            + Tạo tuần TKB
          </button>
        )}

        {loading || (viewerMode && !latestPublishedLoaded) ? (
          <p>Đang tải...</p>
        ) : viewerMode && !latestPublished ? (
          <p style={{ color: "#6b7280", fontSize: 13 }}>{onlyWeekId ? "Tuần này chưa có bản thời khoá biểu nào được công bố." : "Trường chưa công bố bản thời khoá biểu nào."}</p>
        ) : weeks.length === 0 ? (
          <p style={{ color: "#6b7280", fontSize: 13 }}>Chưa có tuần TKB nào — tạo tuần ở trên.</p>
        ) : (
          weeks.map((w) => (
            <div key={w.id} style={{ marginBottom: 4 }}>
              <div onClick={() => { setExpanded((x) => ({ ...x, [w.id]: !x[w.id] })); setSelected({ weekId: w.id, weekOverview: true }); }} style={selected && selected.weekOverview && selected.weekId === w.id ? { ...weekNodeStyle, background: "#f0fdfa" } : weekNodeStyle}>
                <span style={{ width: 14 }}>{expanded[w.id] ? "▾" : "▸"}</span>
                <span style={{ fontWeight: 600 }}>📅 {weekLabel(w)}</span>
                {w.name && <span style={{ fontSize: 11, color: "#9ca3af" }}>({fmt(w.startDate)}–{fmt(w.endDate)})</span>}
                <span style={{ fontSize: 11, color: "#0f766e", background: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: 10, padding: "1px 6px", marginLeft: "auto" }}>{khoiLabel(w)}</span>
              </div>
              {expanded[w.id] && (
                <>
                  {!viewerMode && CHILDREN.filter((c) => !/^xeptay/.test(c.key) || isStrictAdmin).map((c) => {
                    const on = selected && selected.weekId === w.id && selected.childKey === c.key;
                    return (
                      <div key={c.key} onClick={() => setSelected({ weekId: w.id, childKey: c.key })} style={{ ...(on ? childActiveStyle : childStyle), ...(c.sub ? { paddingLeft: ((on ? childActiveStyle : childStyle).paddingLeft || 20) + 18, fontSize: 13 } : {}) }}>
                        {c.icon} {c.label}
                      </div>
                    );
                  })}
                  {!viewerMode && !runsByWeek[w.id] && (
                    <div style={{ ...childStyle, paddingLeft: 20, color: "#9ca3af", cursor: "default" }}>Đang tải các bản...</div>
                  )}
                  {(viewerMode ? viewerRuns(w.id) : (runsByWeek[w.id] || [])).map((run, ri) => (
                    <div key={run.id}>
                      <div style={{ ...childStyle, display: "flex", alignItems: "center", gap: 4, paddingLeft: 20, fontWeight: 600 }}>
                        <span onClick={() => setExpandedRun((x) => ({ ...x, [run.id]: !x[run.id] }))} style={{ display: "flex", alignItems: "center", gap: 4, flex: 1, cursor: "pointer" }}>
                          <span style={{ width: 12 }}>{expandedRun[run.id] ? "▾" : "▸"}</span>
                          {viewerMode ? (run.demo ? "📄 TKB DEMO (xem thử)" : "📄 TKB đã công bố") : `📄 Bản ${(runsByWeek[w.id] || []).length - ri}`} · {fmtTime(run.finishedAt || run.createdAt)}
                          {RUN_STATUS[run.status] ? <span style={{ color: run.status === "failed" ? "#dc2626" : "#b45309", fontWeight: 400 }}> ({RUN_STATUS[run.status]})</span> : null}
                        </span>
                        {!viewerMode && run.status === "done" && (
                          run.published ? (
                            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                              {run.demo ? (
                                <>
                                  <span style={{ fontSize: 11, color: "#b45309", fontWeight: 700 }} title="Bản DEMO: GV/HS xem thử, không tính chấm công, sửa ô không cần duyệt">🧪 Demo</span>
                                  <button
                                    type="button"
                                    onClick={(e) => { e.stopPropagation(); publishRun(run, "official"); }}
                                    disabled={publishing === run.id}
                                    title="Chuyển bản Demo này thành công bố chính thức"
                                    style={{ fontSize: 11, padding: "2px 6px", border: "1px solid #0ea5a3", borderRadius: 6, background: "#fff", color: "#0ea5a3", cursor: "pointer" }}
                                  >
                                    Công bố
                                  </button>
                                </>
                              ) : (
                                <span style={{ fontSize: 11, color: "#059669", fontWeight: 700 }}>📢 Đã công bố</span>
                              )}
                              <button
                                type="button"
                                onClick={(e) => { e.stopPropagation(); unpublishRun(run); }}
                                disabled={publishing === run.id}
                                style={{ fontSize: 11, padding: "2px 6px", border: "1px solid #d1d5db", borderRadius: 6, background: "#fff", cursor: "pointer" }}
                              >
                                Gỡ
                              </button>
                            </span>
                          ) : (
                            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                              <button
                                type="button"
                                onClick={(e) => { e.stopPropagation(); publishRun(run, "official"); }}
                                disabled={publishing === run.id}
                                title="Công bố chính thức: GV/HS xem, tính chấm công, sửa ô phải duyệt"
                                style={{ fontSize: 11, padding: "2px 6px", border: "1px solid #0ea5a3", borderRadius: 6, background: "#fff", color: "#0ea5a3", cursor: "pointer" }}
                              >
                                {publishing === run.id ? "..." : "Công bố"}
                              </button>
                              <button
                                type="button"
                                onClick={(e) => { e.stopPropagation(); publishRun(run, "demo"); }}
                                disabled={publishing === run.id}
                                title="Công bố DEMO: GV/HS xem thử, không tính chấm công, sửa ô không cần duyệt"
                                style={{ fontSize: 11, padding: "2px 6px", border: "1px solid #f59e0b", borderRadius: 6, background: "#fff", color: "#b45309", cursor: "pointer" }}
                              >
                                Demo
                              </button>
                            </span>
                          )
                        )}
                      </div>
                      {expandedRun[run.id] && (run.status === "done" || run.shortfallCount > 0) &&
                        VIEWS.filter((v) => (v.key !== "teacherSub" && v.key !== "postPublish") || isAdminRole).map((v) => {
                          const on = selected && selected.runId === run.id && selected.viewKey === v.key;
                          return (
                            <div key={v.key} onClick={() => setSelected({ weekId: w.id, runId: run.id, viewKey: v.key })} style={on ? { ...childActiveStyle, paddingLeft: 40 } : { ...childStyle, paddingLeft: 40 }}>
                              {v.icon} {v.label}
                            </div>
                          );
                        })}
                    </div>
                  ))}
                </>
              )}
            </div>
          ))
        )}

        {!viewerMode && (
          <div
            onClick={() => setSelected({ special: "trash" })}
            style={selected && selected.special === "trash" ? { ...weekNodeStyle, background: "#0ea5a3", color: "#fff", fontWeight: 700 } : { ...weekNodeStyle, fontWeight: 600 }}
          >
            🗑️ Thùng rác
          </div>
        )}
      </div>
      )}

      {/* Nội dung */}
      <div style={{ flex: 1, minWidth: 320 }}>
        {error && <p style={{ color: "#dc2626" }}>{error}</p>}
        {!selected ? (
          <div style={emptyStyle}>Chọn một tuần và một mục ở cây bên trái. Sau khi "Chạy xếp TKB" xong, mỗi lần chạy hiện thành 1 bản (version) có các view đúng như các file Excel xuất ra: Toàn trường VH / VH-Nghề / TKB Giáo viên / TKB cho GV & Học sinh / TKB Riêng cho Học sinh / Chấm công GV Văn hoá.</div>
        ) : selected.special === "trash" ? (
          <div>
            <h3 style={{ margin: "0 0 12px" }}>🗑️ Thùng rác — Tuần TKB đã xoá</h3>
            <HappySchoolTimetableTrash onRestored={reload} />
          </div>
        ) : selected.weekOverview ? (
          <div style={{ maxWidth: 560 }}>
            <h3 style={{ margin: "0 0 12px" }}>
              📅 {weekLabel(selectedWeek)}{" "}
              <span style={{ fontWeight: 400, color: "#6b7280", fontSize: 14 }}>
                {selectedWeek?.name ? `(${fmt(selectedWeek.startDate)}–${fmt(selectedWeek.endDate)}, ` : "("}
                {khoiLabel(selectedWeek || {})})
              </span>
            </h3>
            {viewerMode ? (
              <p style={{ color: "#6b7280", fontSize: 13 }}>Mở rộng tuần ở cây bên trái để xem TKB đã công bố.</p>
            ) : (
              <>
                <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
                  <b>Khai báo lịch bận:</b> khi <b>MỞ</b>, giáo viên sẽ thấy tuần này để tự khai báo lịch bận; khi <b>ĐÓNG</b> thì không khai báo được nữa.
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: 12, padding: 16, border: "1px solid #e5e7eb", borderRadius: 10, background: "#fff" }}>
                  <span style={{ fontSize: 13, fontWeight: 700, padding: "4px 12px", borderRadius: 999, background: selectedWeek?.busyOpen ? "#dcfce7" : "#f3f4f6", color: selectedWeek?.busyOpen ? "#166534" : "#6b7280" }}>
                    Khai báo bận: {selectedWeek?.busyOpen ? "ĐANG MỞ" : "ĐÃ ĐÓNG"}
                  </span>
                  <button type="button" onClick={() => toggleBusyOpen(selectedWeek)} disabled={busyToggling === selectedWeek?.id}
                    style={selectedWeek?.busyOpen
                      ? { padding: "8px 16px", background: "#fff", color: "#b91c1c", border: "1px solid #fca5a5", borderRadius: 8, cursor: "pointer", fontWeight: 600 }
                      : { padding: "8px 16px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>
                    {busyToggling === selectedWeek?.id ? "Đang xử lý..." : selectedWeek?.busyOpen ? "🔒 Đóng khai báo bận" : "🔓 Mở khai báo bận cho GV"}
                  </button>
                  <button type="button" onClick={() => toggleExcludeChamCong(selectedWeek)} disabled={chamCongToggling === selectedWeek?.id}
                    title="Bật: tuần này (vd Báo giảng/tuần ảo) sẽ KHÔNG tính vào Chấm công của GV, dù có bản TKB đã công bố."
                    style={selectedWeek?.excludeFromChamCong
                      ? { padding: "8px 16px", background: "#fef3c7", color: "#92400e", border: "1px solid #fcd34d", borderRadius: 8, cursor: "pointer", fontWeight: 600 }
                      : { padding: "8px 16px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>
                    {chamCongToggling === selectedWeek?.id ? "Đang lưu..." : selectedWeek?.excludeFromChamCong ? "🧾 Báo giảng — không tính lương" : "🧾 Đánh dấu Báo giảng"}
                  </button>
                  <button type="button" onClick={() => renameWeek(selectedWeek)} disabled={renamingWeek === selectedWeek?.id}
                    style={{ padding: "8px 16px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>
                    {renamingWeek === selectedWeek?.id ? "Đang lưu..." : "✏️ Đổi tên"}
                  </button>
                  <button type="button" onClick={() => deleteWeek(selectedWeek)} disabled={deletingWeek === selectedWeek?.id}
                    style={{ padding: "8px 16px", background: "#fff", color: "#dc2626", border: "1px solid #fca5a5", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>
                    {deletingWeek === selectedWeek?.id ? "Đang xoá..." : "🗑️ Xoá tuần này"}
                  </button>
                </div>
                <p style={{ fontSize: 12, color: "#9ca3af", marginTop: 10 }}>Mở rộng tuần ở cây bên trái để vào Lịch bận, Cấu hình môn học, Chạy xếp TKB…</p>
                <HappySchoolPublishLog key={selectedWeek?.id} schoolId={schoolId} kind="tkb" weekId={selectedWeek?.id} title="📜 Nhật ký công bố của tuần này" />
              </>
            )}
          </div>
        ) : activeView ? (
          <div>
            <h3 style={{ margin: "0 0 12px" }}>
              {activeView.icon} {activeView.label}{" "}
              <span style={{ fontWeight: 400, color: "#6b7280", fontSize: 14 }}>— {weekLabel(selectedWeek)}</span>
            </h3>
            {selected.viewKey === "baocao" ? (
              <HappySchoolRunReport runId={selected.runId} weekId={selected.weekId} />
            ) : selected.viewKey === "baocaotongtiet" ? (
              <HappySchoolRunTotals runId={selected.runId} weekId={selected.weekId} />
            ) : selected.viewKey === "thongke" ? (
              <HappySchoolScheduleStats runId={selected.runId} weekId={selected.weekId} />
            ) : selected.viewKey === "thongkedaythay" ? (
              <HappySchoolSubstituteStats runId={selected.runId} weekId={selected.weekId} />
            ) : selected.viewKey === "teacherAll" ? (
              <HappySchoolAllTeachersView runId={selected.runId} weekId={selected.weekId} canEdit={isAdminRole} />
            ) : selected.viewKey === "pendingEdits" || selected.viewKey === "approvedEdits" ? (
              <HappySchoolPendingEdits runId={selected.runId} initialStatus={selected.viewKey === "approvedEdits" ? "approved" : "applied"} />
            ) : selected.viewKey === "postPublish" ? (
              <HappySchoolPostPublishChanges key={selected.runId} runId={selected.runId} />
            ) : selected.viewKey === "teacherSub" ? (
              <HappySchoolSubstituteBoard key={selected.runId} runId={selected.runId} weekId={selected.weekId} startDate={selectedWeek?.startDate} canEdit={isAdminRole} />
            ) : selected.viewKey === "studentPrintAll" ? (
              <HappySchoolAllClassesView key={`sp-${selected.runId}`} runId={selected.runId} weekId={selected.weekId} studentMode />
            ) : selected.viewKey === "phonghoc" ? (
              <HappySchoolRoomAssignment key={`ph-${selected.weekId}`} weekId={selected.weekId} />
            ) : selected.viewKey === "studentAll" ? (
              <HappySchoolAllClassesView runId={selected.runId} weekId={selected.weekId} canEdit={isAdminRole} />
            ) : (
              <HappySchoolTimetableVersion runId={selected.runId} weekId={selected.weekId} mode={selected.viewKey} khois={selectedWeek?.khois} startDate={selectedWeek?.startDate} isOwner={!viewerMode} isAdmin={isAdminRole} />
            )}
          </div>
        ) : (
          <div>
            <h3 style={{ margin: "0 0 12px" }}>
              {activeChild.icon} {activeChild.label}{" "}
              <span style={{ fontWeight: 400, color: "#6b7280", fontSize: 14 }}>— {weekLabel(selectedWeek)}</span>
            </h3>
            {selected.childKey === "pccmweek" && <HappySchoolPccmByWeek weekId={selectedWeek?.id} weekLabel={weekLabel(selectedWeek)} />}
            {selected.childKey === "lichban" && <HappySchoolTeacherBusy key={selectedWeek?.id} weekId={selectedWeek?.id} />}
            {selected.childKey === "vanhoanghe" && <HappySchoolVanhoaDistribution weekId={selectedWeek?.id} />}
            {selected.childKey === "phonghoc" && <HappySchoolRoomAssignment key={`phe-${selectedWeek?.id}`} weekId={selectedWeek?.id} canEdit={isAdminRole} />}
            {selected.childKey === "pccm" && <HappySchoolPccmQuickEdit />}
            {selected.childKey === "xeptay" && <HappySchoolManualLocks weekId={selectedWeek?.id} />}
            {selected.childKey === "xeptay_tg" && <HappySchoolManualLocks key="tg" weekId={selectedWeek?.id} scope="tg" />}
            {selected.childKey === "xeptay_ttn12" && <HappySchoolManualLocks key="ttn12" weekId={selectedWeek?.id} scope="ttn12" />}
            {selected.childKey === "xeptay_uutien" && <HappySchoolManualLockPriority key={"uutien-" + (selectedWeek?.id || "")} weekId={selectedWeek?.id} />}
            {selected.childKey === "xeptay_calop" && <HappySchoolClassRelock key={"calop-" + (selectedWeek?.id || "")} weekId={selectedWeek?.id} />}
            {selected.childKey === "diemuutien" && <HappySchoolSubjectPriority weekId={selectedWeek?.id} />}
            {selected.childKey === "kiemtra" && <HappySchoolPreflightCheck weekId={selectedWeek?.id} />}
            {selected.childKey === "tkbnghe" && <HappySchoolTKBNghe weekId={selectedWeek?.id} />}
            {selected.childKey === "monhoc" && <HappySchoolSubjectConfig weekId={selectedWeek?.id} khois={selectedWeek?.khois} />}
            {selected.childKey === "blocksize" && <HappySchoolBlockSizeConfig weekId={selectedWeek?.id} />}
            {selected.childKey === "chayxep" && <HappySchoolRunTKB weekId={selectedWeek?.id} onRan={() => loadWeekRuns(selectedWeek?.id)} />}
          </div>
        )}
      </div>

      {showDialog && (
        <div style={overlayStyle} onClick={() => setShowDialog(false)}>
          <div style={dialogStyle} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ margin: "0 0 14px" }}>Tạo tuần TKB</h3>
            <form onSubmit={createWeek}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                <label style={fieldStyle}>
                  <span style={spanStyle}>Từ ngày</span>
                  <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} style={dialogInputStyle} />
                </label>
                <label style={fieldStyle}>
                  <span style={spanStyle}>Đến ngày</span>
                  <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} style={dialogInputStyle} />
                </label>
              </div>
              <div style={spanStyle}>Khối áp dụng:</div>
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap", margin: "8px 0 4px" }}>
                {KHOI_OPTIONS.map((k) => (
                  <label key={k} style={{ fontSize: 14, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                    <input type="checkbox" checked={khois.includes(k)} onChange={() => toggleKhoi(k)} />
                    Khối {k}
                  </label>
                ))}
              </div>
              <div style={{ ...spanStyle, marginTop: 12 }}>Tên tuần (tuỳ chọn):</div>
              <input
                type="text"
                value={weekName}
                onChange={(e) => setWeekName(e.target.value)}
                placeholder="VD: Tuần 21/09–26/09 v2"
                maxLength={100}
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #d1d5db", borderRadius: 6, fontSize: 14, marginTop: 4 }}
              />
              <label style={{ fontSize: 14, display: "flex", alignItems: "center", gap: 6, cursor: "pointer", marginTop: 12 }}
                title="Bật: tuần này là TKB Báo giảng, KHÔNG tính vào Chấm công/lương của GV. Có thể đổi lại sau bằng nút trên tuần.">
                <input type="checkbox" checked={isBaoGiang} onChange={(e) => setIsBaoGiang(e.target.checked)} />
                🧾 Tạo TKB Báo giảng (không tính lương)
              </label>
              <div style={{ marginTop: 16, paddingTop: 12, borderTop: "1px solid #e5e7eb" }}>
                <div style={spanStyle}>Sao chép cấu hình từ tuần đã có (tuỳ chọn):</div>
                <select value={copyFromWeekId} onChange={(e) => pickCopySource(e.target.value)}
                  style={{ width: "100%", padding: "8px 10px", border: "1px solid #d1d5db", borderRadius: 6, fontSize: 14, marginTop: 4 }}>
                  <option value="">— Không sao chép —</option>
                  {weeks.map((w) => (<option key={w.id} value={w.id}>{weekLabel(w)} · {khoiLabel(w)}</option>))}
                </select>
                {copyFromWeekId && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ display: "flex", gap: 12, fontSize: 12, marginBottom: 6 }}>
                      <button type="button" style={linkBtnStyle} onClick={() => setCopyItems(COPY_ITEM_KEYS.filter((k) => (k !== "xeptay" || isStrictAdmin) && (!copyCounts || copyCounts[k] > 0)))}>Chọn tất cả mục có dữ liệu</button>
                      <button type="button" style={linkBtnStyle} onClick={() => setCopyItems([])}>Bỏ chọn hết</button>
                    </div>
                    {COPY_ITEM_KEYS.filter((k) => k !== "xeptay" || isStrictAdmin).map((k) => {
                      const child = CHILDREN.find((c) => c.key === k);
                      const n = copyCounts ? copyCounts[k] : null;
                      return (
                        <label key={k} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, padding: "4px 0", cursor: "pointer", opacity: n === 0 ? 0.6 : 1 }}>
                          <input type="checkbox" checked={copyItems.includes(k)} onChange={() => toggleCopyItem(k)} />
                          <span>{child ? `${child.icon} ${child.label}` : k}</span>
                          <span style={{ marginLeft: "auto", fontSize: 12, color: n === 0 ? "#9ca3af" : "#0f766e" }}>{n === null ? "…" : n === 0 ? "trống" : `${n} mục`}</span>
                        </label>
                      );
                    })}
                    <p style={{ margin: "6px 0 0", fontSize: 12, color: "#6b7280" }}>Chỉ các mục đã tích được sao chép sang tuần mới; tuần nguồn không bị thay đổi.</p>
                  </div>
                )}
              </div>
              {error && <p style={{ color: "#dc2626", fontSize: 13 }}>{error}</p>}
              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 16 }}>
                <button type="button" onClick={() => setShowDialog(false)} style={secondaryBtnStyle} disabled={creatingWeek}>Huỷ</button>
                <button type="submit" style={btnStyle} disabled={creatingWeek}>{creatingWeek ? "Đang tạo..." : "Tạo tuần"}</button>
              </div>
            </form>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

const treeToggleBtnStyle = { padding: "6px 12px", background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db", borderRadius: 999, cursor: "pointer", fontSize: 12, fontWeight: 600, marginBottom: 10 };
const btnStyle = { padding: "8px 14px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600 };
const secondaryBtnStyle = { padding: "8px 14px", background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db", borderRadius: 6, cursor: "pointer" };
const overlayStyle = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 };
const dialogStyle = { background: "#fff", borderRadius: 12, padding: 24, width: "min(520px, 100%)", maxHeight: "92vh", overflowY: "auto", boxShadow: "0 10px 40px rgba(0,0,0,0.2)" };
const linkBtnStyle = { border: "none", background: "transparent", color: "#0f766e", cursor: "pointer", padding: 0, fontSize: 12, fontWeight: 600, textDecoration: "underline" };
const fieldStyle = { fontSize: 13, display: "flex", flexDirection: "column", gap: 4 };
const spanStyle = { color: "#4b5563", fontWeight: 600, fontSize: 13 };
const dialogInputStyle = { padding: 8, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 14 };
const weekNodeStyle = { display: "flex", alignItems: "center", gap: 4, padding: "6px 4px", cursor: "pointer", fontSize: 14, borderRadius: 6 };
const childStyle = { padding: "5px 8px 5px 26px", cursor: "pointer", fontSize: 13, color: "#374151", borderRadius: 6, textAlign: "left" };
const childActiveStyle = { ...childStyle, background: "#0ea5a3", color: "#fff", fontWeight: 600 };
const emptyStyle = { padding: 24, background: "#f9fafb", border: "1px dashed #d1d5db", borderRadius: 10, color: "#6b7280", fontSize: 14 };

export default HappySchoolTKBManager;
